import { ApiClient, createApiClient } from '@/api/client';
import { useSession } from 'next-auth/react';
import React, { createContext, useContext, useState } from 'react';

const ApiClientContext = createContext<ApiClient | null>(null);

type ApiClientProvider = {
  children: React.ReactNode;
};

export const ApiClientProvider = ({ children }: ApiClientProvider) => {
  const session = useSession();
  const jwt = session.data?.accessToken ?? session.data?.jwt;
  const [apiClient] = useState(() => createApiClient(jwt));
  apiClient.setSecurityData(jwt);

  return <ApiClientContext.Provider value={apiClient}>{children}</ApiClientContext.Provider>;
};

const useApi = () => {
  const context = useContext(ApiClientContext);

  if (!context) {
    throw new Error('useApi must be used within an ApiClientProvider');
  }

  return context;
};

export default useApi;
